import { Form } from "antd";
import isEmpty from "lodash/isEmpty";
import WeaTools from "../../wea-tools";
import WeaFormItem from "../../wea-form-item";
import WeaSearchBrowserBox from "../wea-search-browser-box";

class Main extends React.Component {
  getSearchs() {
    const { browserConditions, errorCom } = this.props;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        if (field.conditionType === "CUSTOM") {
          items.push({
            com: (
              <WeaFormItem
                label={`${field.label}`}
                labelCol={{ span: `${field.labelcol}` }}
                wrapperCol={{ span: `${field.fieldcol}` }}
              >
                <div className="wea-ecode-upload-search-customField">
                  <span
                    onClick={e => {
                      window.open(field.linkUrl);
                      e.stopPropagation && e.stopPropagation();
                      e.preventDefault && e.preventDefault();
                      e.nativeEvent && e.nativeEvent.preventDefault();
                    }}
                  >
                    {field.value}
                  </span>
                </div>
              </WeaFormItem>
            ),
            colSpan: field.colSpan
          });
        } else {
          items.push({
            com: (
              <WeaFormItem
                label={`${field.label}`}
                labelCol={{ span: `${field.labelcol}` }}
                wrapperCol={{ span: `${field.fieldcol}` }}
              >
                {errorCom
                  ? errorCom(
                      field,
                      WeaTools.getComponent(
                        field.conditionType,
                        field.browserConditionParam,
                        field.domkey,
                        this.props,
                        field
                      )
                    )
                  : WeaTools.getComponent(
                      field.conditionType,
                      field.browserConditionParam,
                      field.domkey,
                      this.props,
                      field
                    )}
              </WeaFormItem>
            ),
            colSpan: field.colSpan
          });
        }
      });
    return (
      <WeaSearchBrowserBox
        items={items}
        onKeyDown={this.onAdvanceSearchEnter}
      />
    );
  }
  render() {
    const searchsBox = this.getSearchs();
    return <Form horizontal>{searchsBox}</Form>;
  }
}
Main = Form.create({
  onFieldsChange(props, fields) {
    const { changeCondition } = props;
    typeof changeCondition === "function" && changeCondition(fields);
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-login/Search.js